import type { AxiosResponse } from "axios";
import api from "../api";
import { apiWriteThunk } from "../apiWriteThunk";
import {
  POST_TEMPLATE,
  GET_TEMPLATE,
  UPDATE_TEMPLATE,
  DELETE_TEMPLATE,
  GET_TEMPLATE_BY_DESIGN,
  // Save settings reuired to redux
  SAVE_SETTINGS_REQUIRED,
  // Save settings optional to redux
  SAVE_SETTINGS_OPTIONAL,
} from "./templateTypes";
import { GET_ERRORS } from "../errorServices/errorTypes";
import createAppAsyncThunk from "../createAppAsyncThunk";
import { errorPayload } from "../caughtError";
import type { TemplatesResponse, TemplateUpdateResponse } from "../../../../shared/apiTypes";

// Add Template
export const addTemplate = (data) => (dispatch) => {
  return api
    .post("/api/templates/add", data)
    .then((res) => {
      dispatch({
        type: POST_TEMPLATE,
        payload: res.data,
      });
      dispatch(getTemplates())

    })
    .then(() => dispatch({ type: GET_ERRORS, payload: {} }))
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || { message: err.message },
      });
      throw err;
    });
};

//GetAll Templates
export const getTemplates = () => (dispatch) => {
  api
    .get("/api/templates")
    .then((res) =>
      dispatch({
        type: GET_TEMPLATE,
        payload: res.data,
      })
    )
    .catch((err) =>
      // SCRUM-856: surface the real error via the global notification hub instead
      // of dispatching GET_TEMPLATE with null (downstream `.map()` over templates
      // would crash) and silently swallowing the failure. The previously loaded
      // templates are left in place.
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data ?? { message: err?.message },
      })
    );
};
// Templates by design — SCRUM-1016: createAppAsyncThunk so a failed fetch rejects
// and the central appErrorMiddleware surfaces the error, instead of silently
// blanking the by-design list to [] (the editor's template dropdown would just go
// empty, no signal). The success dispatch keeps the legacy GET_TEMPLATE_BY_DESIGN
// action so templateReducer is untouched; on failure the previously loaded list
// stays in place.
export const getTemplatesByDesign = createAppAsyncThunk(
  "templates/getByDesign",
  async (designId: string, { dispatch }) => {
    const res: AxiosResponse<TemplatesResponse> = await api.get(`/api/templates/bydesign/${designId}`);
    dispatch({ type: GET_TEMPLATE_BY_DESIGN, payload: res.data });
    return res.data;
  }
);
//Delete template
export const deleteTemplate = (id) => async (dispatch) => {
  try {
    await api.delete<unknown>(`/api/templates/delete/${id}`);
    dispatch({
      type: DELETE_TEMPLATE,
      payload: id,
    });
    return id;
  } catch (err) {
    // The old catch dispatched DELETE_TEMPLATE with the error body (a success action with
    // an error payload); record it as a proper error and re-throw instead (SCRUM-815).
    dispatch({
      type: GET_ERRORS,
      payload: errorPayload(err),
    });
    throw err;
  }
};
// SCRUM-2119. UpdateTemplate awaits the saved body and catches a rejection
// (SCRUM-815); the wrapper unwraps because dispatch itself resolves to the action.
const putTemplate = apiWriteThunk(
  "templates/update",
  (data) => api.put<TemplateUpdateResponse>("/api/templates/update", data),
  (dispatch, body) => {
    dispatch({ type: UPDATE_TEMPLATE, payload: body });
    dispatch(getTemplates());
  }
);

export const updateTemplate = (data) => (dispatch) => dispatch(putTemplate(data)).unwrap();
//Saving settings required into state update template form
export const saveSettingsRequired = (settingsRequired) => {
  return {
    type: SAVE_SETTINGS_REQUIRED,
    payload: settingsRequired,
  };
};


//Saving settings optional into state update template form
export const saveSettingsOptional = (settingsOptional) => {
  return {
    type: SAVE_SETTINGS_OPTIONAL,
    payload: settingsOptional,
  };
};
